export default "__VITE_ASSET__DqAIRBTt__"